import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { config } from '../config';
import { useI18n } from '../i18n';
import { useApp } from '../app/AppContext';

export function Layout({ children }: { children: ReactNode }) {
  const { t, locale, setLocale } = useI18n();
  const { session, newGuest, endSession, login, guestError, guestState } = useApp();

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        跳到主要內容
      </a>
      <header className="app-header">
        <Link className="app-header__brand" to="/">
          <span aria-hidden="true">⚫⚪</span>
          <span>五子棋</span>
          <small>{t('app.subtitle')}</small>
        </Link>
        <div className="app-header__right">
          {session ? <span title={session.subjectId}>👤 {session.displayName || t('guest.you')}</span> : null}
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => setLocale(locale === 'zh-TW' ? 'en' : 'zh-TW')}
          >
            {t('lang.switch')}
          </button>
        </div>
      </header>

      <main id="main" className="page">
        <section aria-label="身分與工作階段">
          {session?.kind !== 'player' && <>
            <p>訪客身分會在這個瀏覽器延續。共用裝置離開前請結束工作階段；換人時請開始新的訪客身分。登入不會自動歸戶。</p>
            <button disabled={guestState === 'creating'} onClick={() => {
              if (!session || window.confirm('結束目前訪客身分並建立新的？原紀錄會保留，但此瀏覽器將無法再取回。')) void newGuest?.();
            }}>開始新的訪客身分</button>
            {config.oidcIssuer && <>
              <button onClick={() => void login?.(false)}>登入（不歸戶訪客紀錄）</button>
              {session && <button onClick={() => {
                if (window.confirm('確認目前訪客紀錄全部由你本人遊玩？歸戶會將這些紀錄移至你接下來登入的帳號。共用裝置無法辨認真人；不確定時請取消。')) void login?.(true);
              }}>將本次訪客紀錄歸入我的帳號</button>}
            </>}
          </>}
          {session && <button onClick={() => { void endSession?.().catch(() => {}); }}>
            {session.kind === 'player' ? '登出帳號' : '結束訪客工作階段'}
          </button>}
          {guestError && <p role="alert">{guestError}</p>}
        </section>
        {session ? children : <p>工作階段已結束或尚未就緒。請選擇開始新的訪客身分。</p>}
      </main>

      <footer className="app-footer">
        <span>雙人對戰 · 伺服器判定 · 可下載棋譜</span>
        <span>build {config.buildVersion}</span>
      </footer>
    </div>
  );
}
